var staticDecodeURIComponent = decodeURIComponent

module.exports = staticDecodeURIComponent



//////////////////
// WEBPACK FOOTER
// ./~/xe-utils/staticDecodeURIComponent.js
// module id = 334
// module chunks = 98